import xboxRefund from "./schemas/xbox-refund_final.json";
import njParkingTickets from "./schemas/nj-parking-tickets_final.json";
import howToCancelHulu from "./schemas/how-to-cancel-hulu_final.json";
import freeOnlineNotary from "./schemas/free-online-notary_final.json";
import cancelFameassist from "./schemas/cancel-fameassist_final.json";
import cancel42HoursFitness from "./schemas/cancel-24-hour-fitness_final.json";

import { Script } from 'gatsby';
import React from "react";

const schemaForPost = {
    "xbox-refund": JSON.stringify(xboxRefund),
    "nj-parking-tickets": JSON.stringify(njParkingTickets),
    "how-to-cancel-hulu": JSON.stringify(howToCancelHulu),
    "free-online-notary": JSON.stringify(freeOnlineNotary),
    "cancel-fameassist": JSON.stringify(cancelFameassist),
    "cancel-24-hour-fitness": JSON.stringify(cancel42HoursFitness)
}

export const hasSchema = (slug) => {
    return schemaForPost[slug] ? true : false;
}

export const getSchemaForPost = (slug) => {
    return <Script
        id="structured-data-post"
        type="application/ld+json"
    >
        {schemaForPost[slug]}
    </Script>
}